import { createSlice } from "@reduxjs/toolkit";
import { getClaimDetailAPI } from "../../services/getClaimDetail";

const initialState = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const getClaimDetailSlice = createSlice({
  name: "getClaimDetail",
  initialState,
  reducers: {
    getClaimDetailInfo(state) {
      state.isLoading = true;
      state.error = "";
      state.message = "";
    },
    getClaimDetailInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.error = "";
      state.message = "";
    },
    getClaimDetailInfoFailure(state, action) {
      state.isLoading = false;
      state.message = "";
      state.error = action.payload;
      state.data = null;
    },
    getClaimDetailInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const getClaimDetailHandler = (payload) => async (dispatch) => {
  try {
    dispatch(getClaimDetailAction.getClaimDetailInfo());
    const response = await getClaimDetailAPI(payload);
    dispatch(getClaimDetailAction.getClaimDetailInfoSuccess(response));
    return response;
  } catch (e) {
    const errMsg = e?.response?.data?.message || e?.message || String(e);
    dispatch(getClaimDetailAction.getClaimDetailInfoFailure(errMsg));
    throw e;
  }
};

export default getClaimDetailSlice.reducer;
export const getClaimDetailAction = getClaimDetailSlice.actions;
